import React from "react";
import { FaFilePdf } from "react-icons/fa";
import RTIcircular1 from "../assets/documents/RTI Circular 2012.pdf";
import RTIcircular2 from "../assets/documents/RTI Circular 2nd Amendment.pdf";
import { useSelector } from "react-redux";
import { convertToMarathiNumber } from "../components/marathiNumbers";
import { Link } from "react-router-dom";

const Rti = () => {
  const selectedLang = useSelector(
    (state) => state.language.selectedLang || "English"
  );

  const content = {
    English: {
      title: "RTI",
      breadcrumb: "HOME",
      divisionTitle: "RTI",
      // ⭐ FIXED TWO-LINE HEADING
      heading2: (
        <>
          Right to Information Act 2005 (RTI)
          <br />
          List of Officers and First Appellate
        </>
      ),
      docTableHeaders: [
        { id: "srNo", label: "Sr. No." },
        { id: "name", label: "Name" },
        { id: "downloads", label: "Downloads" },
      ],
      docData: [
        { id: 1, name: "RTI Circular 2012", file: RTIcircular1 },
        { id: 2, name: "RTI Circular 2nd Amendment", file: RTIcircular2 },
      ],
    },
    मराठी: {
      title: "माहितीचा अधिकार",
      breadcrumb: "मुख्यपृष्ठ",
      divisionTitle: "माहितीचा अधिकार",
      heading2: (
        <>
          माहितीचा अधिकार अधिनियम २००५ अंतर्गत जनमाहिती अधिकारी व
          <br />
          प्रथम अपिलीय प्राधिकारी यांची माहिती
        </>
      ),
      docTableHeaders: [
        { id: "srNo", label: "अ. क्र." },
        { id: "name", label: "नाव" },
        { id: "downloads", label: "डाउनलोड" },
      ],
      docData: [
        { id: 1, name: "माहिती अधिकार परिपत्रक २०१२", file: RTIcircular1 },
        {
          id: 2,
          name: "माहिती अधिकार परिपत्रक दुसरी सुधारणा",
          file: RTIcircular2,
        },
      ],
    },
  };

  const tableHeaders1 = [
    { key: "department", label: { English: "Department", मराठी: "कक्ष" } },
    {
      key: "rti_officer",
      label: { English: "RTI Officer", मराठी: "जन माहिती अधिकारी" },
    },
    { key: "appellate", label: { English: "Appellate", मराठी: "अपिलीय प्रथम प्राधिकारी" } },
    { key: "email", label: { English: "Email ID", मराठी: "ई- मेल " } },
    {
      key: "contact",
      label: { English: "Contact Number", मराठी: "दूरध्वनी क्रमांक" },
    },
  ];

  const headoffice = [
    {
      id: 1,
      department: {
        English: "Administration",
        मराठी: "आस्थापना",
      },
      rti_officer: {
        English: `Mr. V. G. Shinde
Administrative Officer
Directorate of Archaeology and Museums, Maharashtra,
Mumbai - 400001`,
        मराठी: `श्री. वि. गं. शिंदे प्रशासकीय अधिकारी महाराष्ट्र शासन मुंबई -४०० ००१`,
      },
      appellate: {
        English: `Mr. H.N. Dalavi
Deputy Director
Directorate of Archaeology and Museums
Government of Maharashtra
Mumbai - 400001`,
        मराठी: `श्री.हे.नि.दळवी
उपसंचालक
पुरातत्त्व व वस्तुसंग्रहालये संचालनालय
महाराष्ट्र शासन
मुंबई -४०० ००१`,
      },
      email: `mahaarchaeology@gmail.com`,
      contact: {
        English: "022 -22623380",
        मराठी: "०२२ -२२६२३३८०",
      },
    },
    {
      id: 2,
      department: {
        English: "Conservation",
        मराठी: "जतन",
      },
      rti_officer: {
        English: `Mr. A. V. Patil
 Junior Engineer Directorate of Archaeology and Museums Government of Maharashtra  
Mumbai - 400 001`,
        मराठी: `श्री. अ.वि.पाटील कनिष्ठ अभियंता पुरातत्त्व व वस्तुसंग्रहालये संचालनालय महाराष्ट्र शासन मुंबई -४०० ००१`,
      },
      appellate: {
        English: `Mr. H.N. Dalavi
Deputy Director
Directorate of Archaeology and Museums
Government of Maharashtra
Mumbai - 400 001`,
        मराठी: `श्री.हे.नि.दळवी
उपसंचालक
पुरातत्त्व व वस्तुसंग्रहालये संचालनालय
महाराष्ट्र शासन
मुंबई -४०० ००१`,
      },
      email: `mahaarchaeology@gmail.com`,
      contact: {
        English: "022 -22623380",
        मराठी: "०२२ -२२६२३३८०",
      },
    },
    {
      id: 3,
      department: {
        English: "Archaeology",
        मराठी: "पुरात्तव",
      },
      rti_officer: {
        English: `   Dr. M. B. Thakare   Assistant Archaeologist   Directorate of Archaeology and Museums Government of Maharashtra
Mumbai - 400 001`,
        मराठी: `डॉ. म.बा. ठाकरे पुरातत्त्व सहायक पुरातत्त्व व वस्तुसंग्रहालये संचालनालय महाराष्ट्र शासन मुंबई -४०० ००१`,
      },
      appellate: {
        English: `Mr. H.N. Dalavi
Deputy Director
Directorate of Archaeology and Museums
Government of Maharashtra
Mumbai - 400 001`,
        मराठी: `श्री.हे.नि.दळवी
उपसंचालक
पुरातत्त्व व वस्तुसंग्रहालये संचालनालय
महाराष्ट्र शासन
मुंबई -४०० ००१`,
      },
      email: `mahaarchaeology@gmail.com`,
      contact: {
        English: "022 -22623380",
        मराठी: "०२२ -२२६२३३८०",
      },
    },
    {
      id: 4,
      department: {
        English: "Photography",
        मराठी: "छायाचित्रण",
      },
      rti_officer: {
        English: `Mr. S.S. Pagare
Photographer
Directorate of Archaeology and Museums Government of Maharashtra
Mumbai - 400 001`,
        मराठी: `श्री.स.सु.पगारे छायाचित्रकार पुरातत्त्व व वस्तुसंग्रहालये संचालनालय महाराष्ट्र शासन मुंबई -४०० ००१`,
      },
      appellate: {
        English: `Mr. H.N. Dalavi
Deputy Director
Directorate of Archaeology and Museums
Government of Maharashtra
Mumbai - 400 001`,
        मराठी: `श्री.हे.नि.दळवी
उपसंचालक
पुरातत्त्व व वस्तुसंग्रहालये संचालनालय
महाराष्ट्र शासन
मुंबई -४०० ००१`,
      },
      email: `mahaarchaeology@gmail.com`,
      contact: {
        English: "022 -22623380",
        मराठी: "०२२- २२६२३३८०",
      },
    },
    {
      id: 5,
      department: {
        English: "Accounts Department",
        मराठी: "लेखा शाखा",
      },
      rti_officer: {
        English: `Mrs. N.P. Deshmukh
Assistant Accounts Officer
Directorate of Archaeology and Museums Government of Maharashtra
Mumbai - 400 001`,
        मराठी: `श्रीमती. नि.प्र.देशमुख सहायक लेखाधारी पुरातत्त्व व वस्तुसंग्रहालये संचालनालय महाराष्ट्र शासन मुंबई -४०० ००१`,
      },
      appellate: {
        English: `Mr. H.N. Dalavi
Deputy Director
Directorate of Archaeology and Museums
Government of Maharashtra
Mumbai - 400 001`,
        मराठी: `'श्री.हे.नि.दळवी
उपसंचालक
पुरातत्त्व व वस्तुसंग्रहालये संचालनालय
महाराष्ट्र शासन
मुंबई -४०० ००१`,
      },
      email: `mahaarchaeology@gmail.com`,
      contact: {
        English: "022 -22623380",
        मराठी: "०२२- २२६२३३८०",
      },
    },
    {
      id: 6,
      department: {
        English: "Museum",
        मराठी: "संग्रहालय",
      },
      rti_officer: {
        English: `Mr. Vijay Shinde
Administrative Officer
Archaeology and Museums
Government of Maharashtra
Mumbai - 400 001`,
        मराठी: `श्री.अ.उ.गोसावी सहायक पुरातत्त्व व वस्तुसंग्रहालये संचालनालय महाराष्ट्र शासन मुंबई -४०० ००१`,
      },
      appellate: {
        English: `Mr. H.N. Dalavi
Deputy Director
Directorate of Archaeology and Museums
Government of Maharashtra
Mumbai - 400 001`,
        मराठी: `'श्री.हे.नि.दळवी
उपसंचालक
पुरातत्त्व व वस्तुसंग्रहालये संचालनालय
महाराष्ट्र शासन
मुंबई -४०० ००१`,
      },
      email: `mahaarchaeology@gmail.com`,
      contact: {
        English: "022 -22623380",
        मराठी: "०२२- २२६२३३८०",
      },
    },
  ];

  const t = content[selectedLang];

  return (
    <div className="px-4 py-12">
      {/* ---------------- HEADER ---------------- */}
      <div className="text-center mb-8">
        <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
          {t.title}
        </h1>

        <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-2">
          <span style={{ color: "#DD9827" }}>
            <Link to="/" className="hover:underline">
              {t.breadcrumb}
            </Link>{" "}
            /{" "}
          </span>
          {t.divisionTitle}
        </p>
      </div>

      {/* ---------------- DOWNLOAD TABLE ---------------- */}
      <div
        className="max-w-6xl mx-auto bg-[#EFEDE0] rounded-xl shadow overflow-x-auto"
        style={{ border: "2px solid #F8D6BF" }}
      >
        <table className="min-w-full bg-[#EFEDE0] text-center text-black text-sm sm:text-base">
          <thead
            className="font-bold tracking-wide"
            style={{ textShadow: "0.3px 0.3px 0 black" }}
          >
            <tr>
              {t.docTableHeaders.map((header) => (
                <th
                  key={header.id}
                  className="px-4 py-4 border-r-2"
                  style={{ borderColor: "#F8D6BF" }}
                >
                  {header.label}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {t.docData.map((item, index) => (
              <tr key={item.id} className="hover:bg-[#F6F6EC]">
                <td
                  className="px-4 py-4 border-t-2 border-r-2"
                  style={{ borderColor: "#F8D6BF" }}
                >
                  {selectedLang === "मराठी"
                    ? convertToMarathiNumber(index + 1)
                    : index + 1}
                  .
                </td>

                <td
                  className="px-4 py-4 border-t-2 border-r-2"
                  style={{ borderColor: "#F8D6BF" }}
                >
                  {item.name}
                </td>

                <td
                  className="px-4 py-4 border-t-2 flex justify-center items-center"
                  style={{ borderColor: "#F8D6BF" }}
                >
                  <a
                    href={item.file}
                    download
                    className="text-red-600 hover:text-red-800"
                  >
                    <FaFilePdf size={20} />
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ---------------- HEAD OFFICE TABLE ---------------- */}
      <div className="mt-12 p-6" id="archaeology">
        <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black pb-10 leading-snug md:leading-normal ">
          {t.heading2}
        </h1>

        <div
          className="overflow-x-auto rounded-xl"
          style={{ border: "2px solid #F8D6BF", background: "#EFEDE0" }}
        >
          <table className="w-full min-w-[800px] text-sm sm:text-base text-black text-center">
            <thead
              className="font-bold tracking-wide"
              style={{ textShadow: "0.3px 0.3px 0 black" }}
            >
              <tr>
                {tableHeaders1.map((header) => (
                  <th
                    key={header.key}
                    className="py-3 px-4 border-r-2 text-nowrap"
                    style={{ borderColor: "#F8D6BF" }}
                  >
                    {header.label[selectedLang]}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {headoffice.map((person) => (
                <tr key={person.id}>
                  <td
                    className="py-3 px-4 border-t-2 border-r-2"
                    style={{ borderColor: "#F8D6BF" }}
                  >
                    {person.department[selectedLang]}
                  </td>

                  <td
                    className="py-3 px-4 border-t-2 border-r-2"
                    style={{ borderColor: "#F8D6BF" }}
                  >
                    {person.rti_officer[selectedLang]}
                  </td>
                  <td
                    className="py-3 px-4 border-t-2 border-r-2"
                    style={{ borderColor: "#F8D6BF" }}
                  >
                    {person.appellate[selectedLang]}
                  </td>
                  <td
                    className="py-3 px-4 border-t-2 border-r-2"
                    style={{ borderColor: "#F8D6BF" }}
                  >
                    {person.email}
                  </td>

                  <td
                    className="py-3 px-4 border-t-2 text-nowrap"
                    style={{ borderColor: "#F8D6BF" }}
                  >
                    {person.contact[selectedLang]}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Rti;
